import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const StyledSocialMediaLinks = styled.ul(
  ({ theme }) => `
  list-style-type: none;
  display: flex;
  gap: ${theme.size.static150};
  padding: 0;
  margin: 0;

  li {
    padding: ${theme.size.static150};

    a {
      display: block;
    }
  }


  img {
    width: 32px;
    height: 32px;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    li {
      padding: 0;
    }

    img {
      height: 24px;
      width: 24px;
    }
  }
`
);
